export default __webpack_public_path__ + "static/media/thoni_915_1.79be01be.jpg";